import {Risikopaare} from '../risikopaare';
import {ChartsPersonalbestand} from './chartsPersonalbestand';
import {ChartsPersonenUndStellenbezogeneMerkmale} from './chartsPersonenUndStellenbezogeneMerkmale';
import {ChartsVerteilungLeaveOneOut} from './chartsVerteilungLeaveOneOut';
import {FunktionswertGesamtverdienst} from './funktionswert-gesamtverdienst';
import {KoefUndIntervalle} from './geschaetzteKoeffKonfidenzintervalle';
import {Lohnbaender} from './lohnbaender';
import {SeriesAbsolutPerc} from './seriesAbsolutPerc';

export class Charts {
  personalbestand: ChartsPersonalbestand;
  gesamtverdienstUndLohnbestandteile: SeriesAbsolutPerc;
  lohnverteilung: string;
  personenUndStellenbezogeneMerkmale: ChartsPersonenUndStellenbezogeneMerkmale;
  lohnsumme: SeriesAbsolutPerc;
  koefUndIntervalle: KoefUndIntervalle;
}

export class ChartsM2 {
  personalbestand: ChartsPersonalbestand;
  gesamtverdienstUndLohnbestandteile: SeriesAbsolutPerc;
  lohnverteilung: string;
  risikopaare: Risikopaare;
  lohnsumme: SeriesAbsolutPerc;
  funktionswertGesamtverdienst: FunktionswertGesamtverdienst;
  lohnbaender: Lohnbaender;
}

export class AdvancedCharts {
  histogram: ChartsVerteilungLeaveOneOut;
}

export class AdvancedChartsM2 {
  histogram: ChartsVerteilungLeaveOneOut;
}
